module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"prop-header\"><span class=\"prop-label\">Hold App Instance ID</span></div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-9 subsection nopadding-r\" style=\"padding-right:5px!important;\">\r\n        <label class=\"prop-sublabel label-35\">Field</label>\r\n        <div>\r\n            <input type=\"text\" name=\"ValueOfAField\" id=\"ValueOfAField\" disabled value=\"")
    ; __append(escapeFn(ValueOfAField))
    ; __append("\" />\r\n        </div>\r\n    </div>\r\n    <div class=\"col-md-3 nopadding\" style=\"text-align: right;\">\r\n        <button id=\"ValueOfAFieldButton\" name=\"ValueOfAFieldButton\" class=\"btn btn-default hvr-glow select-button\">Select</button>\r\n    </div>\r\n</div>")
  }
  return __output;

}